import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'model/State';
import {
  OrderCenterPaginationProps,
  OrderCenterTableItems,
  OrderSearchFiltersForPagination,
  OrdersPage,
  OrdersPageProps,
} from './OrdersPage';
import {
  selectInvoices,
  selectInvoicesResponse,
  selectSingleOrderResponse,
} from './duck/selectors';
import { fetchSearchForContactPost } from './duck/actions/invoices';

// this component can be used to show a particular order
// and scrolled into view port using URL: `/purchase/my/billing/quotes/{orderId}?hash=:hash`
export const MACInvoicesPage = (props: Pick<OrdersPageProps, 'orderId'>) => {
  const dispatch = useDispatch();
  const initialPaginationState: OrderCenterPaginationProps = {
    maxResult: 10,
    offset: 0,
    totalItems: 10, // should be deprecated after getting rid of old pagination
    maxCachedPages: 0,
    latestPageNumber: 0,
  };
  const [pagination, setPagination] = useState<OrderCenterPaginationProps>(initialPaginationState);
  const [searchFilters, setSearchFilters] = useState<OrderSearchFiltersForPagination>({});

  const updateSearchFilters = (value: OrderSearchFiltersForPagination) => {
    setSearchFilters(value);
    setPagination({ ...initialPaginationState, maxResult: pagination.maxResult });
  };

  const invoicesResponse = useSelector((state) => selectInvoicesResponse(state as State));
  const invoices = (invoicesResponse?.ifSuccess((r) => r)?.results ||
    null) as OrderCenterTableItems;

  const singleInvoiceResponse = useSelector((state) =>
    selectSingleOrderResponse(Number(props.orderId), state as State),
  );
  const singleInvoice = singleInvoiceResponse?.ifSuccess((r) => r);

  const totalResults = useSelector((state) => selectInvoices(state as State)?.totalAvailable || 0);
  const hasMoreResults = useSelector((state) => selectInvoices(state as State)?.hasMoreResults);

  useEffect(() => {
    if (totalResults > 0) {
      setPagination({
        ...pagination,
        totalItems: totalResults,
      });
    }
  }, [totalResults]);

  const handlePaginationChange = (params: {
    limit?: number;
    offset?: number;
    maxCachedPages?: number;
    latestPageNumber?: number;
  }) => {
    setPagination({
      ...pagination,
      maxResult: params.limit || pagination.maxResult,
      offset: params.offset || 0,
      maxCachedPages: params.maxCachedPages || 0,
      latestPageNumber: params.latestPageNumber || 0,
    });
    dispatch(
      fetchSearchForContactPost(
        params.limit || pagination.maxResult,
        params.offset || 0,
        searchFilters.orderNumberMask,
        searchFilters.technicalContactCompanyDomainName,
        searchFilters.integerPartOfTotalAmount,
      ),
    );
  };

  return (
    <OrdersPage
      items={invoices || (singleInvoice ? [singleInvoice] : null)}
      isItemsLoading={invoicesResponse?.inProgress || singleInvoiceResponse?.inProgress}
      pagination={pagination}
      onPaginationChange={handlePaginationChange}
      hasMoreResults={hasMoreResults}
      onSearchByFilters={updateSearchFilters}
      {...props}
    />
  );
};
